<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import indowCorner from './images/Indow-MF3-Interior-CMYK-MED-HR-1200x798.jpg';
	import chart from './images/Tips-for-Energy-Efficient-Homes-Chart-B.jpg';
	import womanThermostat from './images/Woman-thermostat-1200x800.jpg';
</script>

<Section class="max-md:pt-0">
	<Image
		src={womanThermostat}
		alt="A person wearing a purple shirt is installing a window insert."
		description="Energy Efficiency 101"
	/>

	<p>
		With constant supply chain disruptions and inflation rising, the costs of
		living have risen in almost every way. From groceries to monthly utility
		bills, now may be the time to reassess your expenses. One way to reduce your
		utility bills is by increasing the energy efficiency of your home, which can
		be done in a variety of ways.
	</p>
	<p>
		Generally, energy efficiency involves a combination of sealing and
		insulating the building envelope of your home. The <strong
			>building envelope</strong
		> refers to the walls, ceilings, and floors that enclose the living space.
	</p>
	<p>
		<strong>Sealing</strong> your building envelope reduces the amount of air leaking
		in and out of your home. Reducing air leakage means that comfortable temperatures
		stay in the house and noise (which travels through air) is kept outside of the
		house. Windows are one of the most important components of the building envelope
		that need to be sealed.
	</p>
	<p>
		<strong>Insulating</strong> your home adds layers of protection against heat or
		air conditioning loss. Thermal insulation slows the transfer of heat or cold and
		insulation also helps reduce noise as well by absorbing noise particles. Combining
		attic insulation and basement ceiling insulation helps floors above and below
		stay at a comfortable temperature. Of course, installing new insulation in your
		walls helps considerably, but involves an intrusive installation project.
	</p>

	<p>
		This bedroom has two sets of curtains, one that is a light material and then
		a heavy-duty curtain that is on top.
	</p>

	<Image
		src="/static/routes/resources/blog/ways-to-save-with-energy-efficiency/IW-building-efficiency-upgrades-animated-web.gif"
		description="How to Improve your Home’s Building Envelope and Save Money"
	/>

	<p>
		There are various ways to upgrade your home’s building envelope and save you
		money. Here are a few tips we recommend:
	</p>

	<ul>
		<li>Insulate your attic and basement ceilings</li>
		<li>Insulate your walls</li>
		<li>
			Air seal your home with weatherstripping, caulk, or door draft stoppers
		</li>
		<li>
			Weatherize your windows with interior storm windows, also known as window
			inserts
		</li>
		<li>
			Upgrade heating and cooling equipment, such as heat pumps, boilers, or
			furnaces
		</li>
		<li>
			Update appliances to the latest energy efficiency technology, specifically
			products with high Energy Star ratings
		</li>
		<li>
			Renovate your roof to a reflective surface, which helps keep your roof and
			home cooler during hot months, lowering your energy bill and extending the
			life of your roof
		</li>
		<li>
			Upgrade to renewable energy, such as solar panels, to reduce energy
			consumption
		</li>
	</ul>
	<Image
		src={chart}
		alt="Tips for Energy Efficient Homes Chart B"
		description="How to Save Big on Energy Efficiency with the Inflation Reduction Act"
	/>
	<p>
		By installing insulation material, upgrading to new heating or cooling
		equipment, or sealing your home to prevent heat loss inside your home, you
		can <a href="/how-to/get-home-energy-efficiency-tax-credits"
			>save money with the Home Energy Improvement Tax Credit</a
		>. You can do this within your home through a variety of methods, which
		means you have many options to improve the energy efficiency of your home –
		and the federal government will help you save money while doing it!
	</p>
	<p>
		One of the easiest and most cost-effective ways to take advantage of these
		federal tax credits is by installing energy efficient window inserts. Window
		inserts create an air seal – weatherizing your windows and increasing your
		energy efficiency.
	</p>
	<Image
		src={indowCorner}
		alt="Indow MF3 Interior CMYK MED HR"
		description="Indow Is Your Energy Efficient Window Solution"
	/>

	<p>
		With the help of the Energy Efficient Home Improvement Credit, <a
			href="/window-insert-tax-savings"
			>you can save up to $1200 on Indow window inserts</a
		> that improve the energy efficiency of your home, eliminate cold drafts in the
		winter, and keep your home cooler in the summer.
	</p>
	<p>
		Indow window inserts are the most sustainable and energy-efficient method to
		seal your window. No replacement or modification of the window frame
		required. Indow’s Snug Fit guarantee ensures that your inserts will slide
		right into your existing window frame, immediately creating an insulating
		pocket that keeps your home at a comfortable temperature and a quiet volume.
	</p>

	<p>
		You’ll feel the comfort and see the savings in your utility bills
		immediately as Indow customers save an average of 20% on heating & cooling
		bills. Additionally, Indow’s thermal inserts seal out pollen, pollutants,
		and can even reduce outside noise by at least 50%, allowing you to enjoy
		your space more while saving money.
	</p>
	<p>
		<a href="/solutions/insulating-drafty-windows">Learn more</a> about how
		Indow inserts can improve your home’s energy efficiency and save you money.
		<a href="/how-to/get-indow-inserts"
			>Talk to one of our experts today to get a free estimate</a
		>!
	</p>
</Section>
